import axios from "axios";
import UtilsUrl from "../utils/UtilsUrl";

const header = { Authorization: "Bearer " + sessionStorage.getItem("Token") };

class BillService {
  allTypeBills(typeBill, isGenerated, isDeleted) {
    return axios.get(
      UtilsUrl.billURL() +
      "/getTypeBillActiveDeleteTypeBill/" +
      typeBill +
      "/" +
      isGenerated +
      "/" +
      isDeleted,
      { headers: header }
    );
  }
  allTypeBillsForAdd(isGenerated, isDeleted, isIncome) {
    return axios.get(
      UtilsUrl.billURL() +
      "/getTypeBillActiveDeleteIncome/" +
      isGenerated +
      "/" +
      isDeleted +
      "/" +
      isIncome,
      { headers: header }
    );
  }

  getTypeBillById(idTypeBill) {
    return axios.get(UtilsUrl.billURL() + "/getTypeBillById/" + idTypeBill, {
      headers: header,
    });
  }

  getBillAndExrats(idBill) {
    return axios.get(UtilsUrl.billURL() + "/getBillEndExtratID/" + idBill, {
      headers: header,
    });
  }

  getBillAndExratsRefFacture(refFacture, typeFacture) {
    return axios.get(
      UtilsUrl.billURL() +
      "/getBillEndExtratRefFactureTypeBill/" +
      refFacture +
      "/" +
      typeFacture,
      { headers: header }
    );
  }

  allBillsTypeBill(typeBill, isActive, isDeleted) {
    return axios.get(
      UtilsUrl.billURL() +
      "/getBillsGeneratedDeleteTypeBill/" +
      typeBill +
      "/" +
      isActive +
      "/" +
      isDeleted,
      { headers: header }
    );
  }

  numberNotPayedBill(typeBill, payed, isActive, isDeleted, idUser) {
    return axios.get(
      UtilsUrl.billURL() +
      "/getNumberBillsPayedGeneratedDeleteTypeBill/" +
      typeBill +
      "/" +
      payed +
      "/" +
      isActive +
      "/" +
      isDeleted,
      { headers: header }
    );
  }
  allBillsPayed(idSociete, idUser, isIncome, payed, isActive, isDeleted) {
    return axios.get(
      UtilsUrl.billURL() +
      "/listBillPayedState/" +
      idSociete +
      "/" +
      idUser +
      "/" +
      isIncome +
      "/" +
      payed +
      "/" +
      isActive +
      "/" +
      isDeleted,
      { headers: header }
    );


  }

  allBillsPayedWithFilter(idSociete, idUser, payed, isActive, isDeleted, month, year) {
    let idSupllierForBackend = "any";
    let monthForBackend = "any";
    let yearForBackend = "any";

    if (idSociete === "any") {
      idSupllierForBackend = 0;
    } else {
      idSupllierForBackend = parseInt(idSociete);
    }

    if (month !== "00") {
      monthForBackend = month;
    }

    if (year !== "00") {
      yearForBackend = year;
    }

    return axios.get(
      UtilsUrl.billURL() +
      "/allBillsPayedWithFilter/" +
      idSupllierForBackend +
      "/" +
      idUser +
      "/" +
      payed +
      "/" +
      isActive +
      "/" +
      isDeleted +
      "/" +
      monthForBackend +
      "/" +
      yearForBackend,
      { headers: header }
    );
  }

  amountTTAllBillsPayed(
    idSociete,
    idUser,
    isIncome,
    payed,
    isActive,
    isDeleted
  ) {
    return axios.get(
      UtilsUrl.billURL() +
      "/amountTTAllBillsPayed/" +
      idSociete +
      "/" +
      idUser +
      "/" +
      isIncome +
      "/" +
      payed +
      "/" +
      isActive +
      "/" +
      isDeleted,
      { headers: header }
    );
  }
  allBillsType(idTypeBill, isActive, isDeleted) {
    return axios.get(
      UtilsUrl.billURL() +
      "/getBillsTypeGeneratedDelete/" +
      idTypeBill +
      "/" +
      isActive +
      "/" +
      isDeleted,
      { headers: header }
    );
  }
  addTypeBill(bill) {
    return axios.post(UtilsUrl.billURL() + "/addTypeBill", bill, {
      headers: header,
    });
  }

  addBill(bill) {
    return axios.post(UtilsUrl.billURL() + "/addBill", bill, {
      headers: header,
    });
  }

  addBillBC(bill) {
    return axios.post(UtilsUrl.billURL() + "/addBillBC", bill, {
      headers: header,
    });
  }

  addExtratBill(extrat) {
    return axios.post(UtilsUrl.billURL() + "/addExtractBill", extrat, {
      headers: header,
    });
  }

  payerBill(idBill, payed) {
    return axios.get(
      UtilsUrl.billURL() + "/payerBill/" + idBill + "/" + payed,
      { headers: header }
    );
  }
  supprimerBill(idBill) {
    return axios.get(UtilsUrl.billURL() + "/deleteBill/" + idBill, {
      headers: header,
    });
  }
  confirmFacture(idBill, generete) {
    return axios.get(
      UtilsUrl.billURL() + "/confirmBill/" + idBill + "/" + generete,
      { headers: header }
    );
  }
  getCheque(idBill) {
    return axios.get(UtilsUrl.billURL() + "/getCheque/" + idBill, {
      headers: header,
    });
  }
  getEcheances(idBill) {
    return axios.get(UtilsUrl.billURL() + "/getEcheances/" + idBill, {
      headers: header,
    });
  }
  payerFactureEspece(payement) {
    return axios.post(UtilsUrl.billURL() + "/payerFactureEspece", payement, {
      headers: header,
    });
  }
  payerFactureCheque(idBill, payed) {
    return axios.get(
      UtilsUrl.billURL() + "/payerFactureCheque/" + idBill + "/" + payed,
      { headers: header }
    );
  }
  getRetenuSource() {
    return axios.get(UtilsUrl.retenuURL() + "/getRetenuSource", {
      headers: header,
    });
  }

  fileRetenuSource(idBill) {
    return axios.get(UtilsUrl.retenuURL() + "/genererRetenu/" + idBill, {
      headers: header,
    });
  }

  validateBill(idBill) {
    return axios.get(UtilsUrl.billURL() + "/validateBill/" + idBill, {
      headers: header,
    });
  }
  deleteBillDraft(idBill) {
    return axios.get(UtilsUrl.billURL() + "/deleteBillDraft/" + idBill, {
      headers: header,
    });
  }

  // getMaxAmountBC(idBC){
  //   return axios.get(billURL() + "/getMaxAmountBC/" + idBC );
  // }

  payerChequeAvanceBill(payement) {
    return axios.post(UtilsUrl.billURL() + "/payerChequeAvanceBill", payement, {
      headers: header,
    });
  }

  payerEnLigneAvanceBill(payement) {
    return axios.post(
      UtilsUrl.billURL() + "/payerEnLigneAvanceBill",
      payement,
      { headers: header }
    );
  }

  payerEspeceAvanceBill(payement) {
    return axios.post(UtilsUrl.billURL() + "/payerEspeceAvanceBill", payement, {
      headers: header,
    });
  }

  payerChequeTotalBill(payement) {
    return axios.post(UtilsUrl.billURL() + "/payerChequeTotalBill", payement, {
      headers: header,
    });
  }

  payerEnLigneTotalBill(payement) {
    return axios.post(UtilsUrl.billURL() + "/payerEnLigneTotalBill", payement, {
      headers: header,
    });
  }

  payerEspeceTotalBill(payement) {
    return axios.post(UtilsUrl.billURL() + "/payerEspeceTotalBill", payement, {
      headers: header,
    });
  }
  payerVirementTotalBill(payement) {
    return axios.post(
      UtilsUrl.billURL() + "/payerVirementTotalBill",
      payement,
      { headers: header }
    );
  }
  payerVirementAvanceBill(payement) {
    return axios.post(
      UtilsUrl.billURL() + "/payerVirementAvanceBill",
      payement,
      { headers: header }
    );
  }

  listAvancePayementBill(idBill) {
    return axios.get(UtilsUrl.billURL() + "/getAvancesPayementBill/" + idBill, {
      headers: header,
    });
  }

  listTotalPayementBill(idBill) {
    return axios.get(UtilsUrl.billURL() + "/getTotalPayementBill/" + idBill, {
      headers: header,
    });
  }

  getFacturesByFilterForPayementTask = (
    idUser,
    isPayedForBackend,
    idSupplier,
    month,
    year
  ) => {
    let idSupllierForBackend = "any";
    let monthForBackend = "any";
    let yearForBackend = "any";

    if (idSupplier === "any") {
      idSupllierForBackend = 0;
    } else {
      idSupllierForBackend = parseInt(idSupplier);
    }

    if (month !== "00") {
      monthForBackend = month;
    }

    if (year !== "00") {
      yearForBackend = year;
    }
    return axios.get(
      UtilsUrl.billURL() +
      "/getFacturesByFilterForPayementTask/" +
      idUser +
      "/" +
      isPayedForBackend +
      "/" +
      idSupllierForBackend +
      "/" +
      monthForBackend +
      "/" +
      yearForBackend,
      {
        headers: header,
      }
    );
    // return api.get(
    //   `/retail/document/getFacturesByFilterForPayementTask/${currentUser}/${isPayedForBackend}/${idSupllierForBackend}/${monthForBackend}/${yearForBackend}`
    // );

  };
}
export default new BillService();
